import { Title } from '@/components/commons/typography/Title'
import { SocialIconButtonWithWeb } from '@/components/social-networks/SocialIconButtonWithWeb'
import { ISocialPlatform } from '@/interfaces/socials'
import { useHighlightEditorStore } from 'containers/highlights/store/highlightEditor'

const ALL_SOCIALS = Object.keys(ISocialPlatform).map(
  (key) => ISocialPlatform[key]
)

export const HSocialNetwork = () => {
  const { highlight, updateHighlight } = useHighlightEditorStore()

  const socials = [...ALL_SOCIALS, 'web']

  const isSelected = (social: string) => {
    return highlight?.contentPlatform === social
  }

  return (
    <div className="flex flex-column gap-8">
      <Title as="label" variation="xSmall">
        Select Social Network
      </Title>
      <div className="flex gap-12 wrap">
        {socials.map((social) => (
          <SocialIconButtonWithWeb
            key={`${social}_highlight_editor`}
            social={social}
            size={30}
            filterGray={!isSelected(social)}
            onClick={(s) => updateHighlight({ contentPlatform: s })}
          />
        ))}
      </div>
    </div>
  )
}
